import { Weekday } from '../helpers/time-utils';

type GraphsAndTexts = {
    [key in Weekday]: {
        startTime: number;
        graph: string;
        graphTitle: string;
        graphText: string;
        openingHoursKey: string;
        closedRestOfTheDay: boolean;
    }[];
};
export const getGraphAndTexts = (key: Weekday) => {
    return graphsAndTexts[key];
};

const graphsAndTexts: GraphsAndTexts = {
    mon: [
        {
            startTime: 0,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_mon.svg',
            graphTitle: 'label.graph.title.open.monTueWedThuFri',
            graphText: 'label.graph.text.open.mon',
            openingHoursKey: 'mon',
            closedRestOfTheDay: false,
        },
        {
            startTime: 1800,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_tue.svg',
            graphTitle: 'label.graph.title.closed.monTueWedThuFriSatSun',
            graphText: 'label.graph.text.closed.monTueWedThu',
            openingHoursKey: 'tue',
            closedRestOfTheDay: true,
        },
    ],
    tue: [
        {
            startTime: 0,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_tue.svg',
            graphTitle: 'label.graph.title.open.monTueWedThuFri',
            graphText: 'label.graph.text.open.tueWedThuFri',
            openingHoursKey: 'tue',
            closedRestOfTheDay: false,
        },
        {
            startTime: 1800,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_wed.svg',
            graphTitle: 'label.graph.title.closed.monTueWedThuFriSatSun',
            graphText: 'label.graph.text.closed.monTueWedThu',
            openingHoursKey: 'wed',
            closedRestOfTheDay: true,
        },
    ],
    wed: [
        {
            startTime: 0,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_wed.svg',
            graphTitle: 'label.graph.title.open.monTueWedThuFri',
            graphText: 'label.graph.text.open.tueWedThuFri',
            openingHoursKey: 'wed',
            closedRestOfTheDay: false,
        },
        {
            startTime: 1800,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_thu.svg',
            graphTitle: 'label.graph.title.closed.monTueWedThuFriSatSun',
            graphText: 'label.graph.text.closed.monTueWedThu',
            openingHoursKey: 'thu',
            closedRestOfTheDay: true,
        },
    ],
    thu: [
        {
            startTime: 0,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_thu.svg',
            graphTitle: 'label.graph.title.open.monTueWedThuFri',
            graphText: 'label.graph.text.open.tueWedThuFri',
            openingHoursKey: 'thu',
            closedRestOfTheDay: false,
        },
        {
            startTime: 1800,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_fri.svg',
            graphTitle: 'label.graph.title.closed.monTueWedThuFriSatSun',
            graphText: 'label.graph.text.closed.monTueWedThu',
            openingHoursKey: 'fri',
            closedRestOfTheDay: true,
        },
    ],
    fri: [
        {
            startTime: 0,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_fri.svg',
            graphTitle: 'label.graph.title.open.monTueWedThuFri',
            graphText: 'label.graph.text.open.tueWedThuFri',
            openingHoursKey: 'fri',
            closedRestOfTheDay: false,
        },
        {
            startTime: 1700,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_mon.svg',
            graphTitle: 'label.graph.title.closed.monTueWedThuFriSatSun',
            graphText: 'label.graph.text.closed.friSatSun',
            openingHoursKey: 'mon',
            closedRestOfTheDay: true,
        },
    ],
    sat: [
        {
            startTime: 0,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_mon.svg',
            graphTitle: 'label.graph.title.closed.monTueWedThuFriSatSun',
            graphText: 'label.graph.text.closed.friSatSun',
            openingHoursKey: 'mon',
            closedRestOfTheDay: true,
        },
    ],
    sun: [
        {
            startTime: 0,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_mon.svg',
            graphTitle: 'label.graph.title.closed.monTueWedThuFriSatSun',
            graphText: 'label.graph.text.closed.friSatSun',
            openingHoursKey: 'mon',
            closedRestOfTheDay: true,
        },
    ],
    holiday: [
        {
            startTime: 0,
            graph: 'https://www.topdanmark.dk/binaries/content/gallery/svg-graphics/kontakt-os/graph_mon.svg',
            graphTitle: 'label.graph.title.closed.monTueWedThuFriSatSun',
            graphText: 'label.graph.text.closed.holiday',
            openingHoursKey: 'mon',
            closedRestOfTheDay: true,
        },
    ],
};
